import React from 'react';

const Footer = () =>
    <footer>
        <div className="container">
    		<p>Built with <a href="https://reactjs.org/">React.js</a></p>
            <p>Designed by Chris Lindeman (
            	<a href="mailto:chris.lindeman@gmail.com">
            		chris.lindeman at gmail.com
        		</a>
    		)</p>
        </div>
    </footer>

export default Footer;
